// Mirrors trpc.supplierInvoices outputs (apps/web/src/api/trpc/routers/supplier-invoices.ts).

export type InvoiceStatus = "open" | "paid" | "void";
export type InvoiceFilter = "open" | "overdue" | "paid" | "void" | null;
export type PaymentMethod = "bank_transfer" | "cash" | "card" | "direct_debit" | "other";
export const PAYMENT_METHODS: PaymentMethod[] = ["bank_transfer", "cash", "card", "direct_debit", "other"];

export type InvoiceSummary = {
  id: number;
  supplier_id: number | null;
  supplier_name: string | null;
  invoice_number: string | null;
  issue_date: string;
  due_date: string | null;
  currency: string | null;
  total: number;
  status: InvoiceStatus;
  is_overdue: boolean;
  paid_at: string | null;
  has_document: boolean;
  receipt_count: number;
};

export type InvoiceTotals = {
  open_total: number;
  open_count: number;
  overdue_total: number;
  overdue_count: number;
  due_soon_total: number;
  paid_30d_total: number;
};

export type InvoiceLine = {
  description: string;
  supplier_code: string | null;
  quantity: number | null;
  unit: string | null;
  unit_price: number | null;
  vat_rate: number | null;
  line_total: number | null;
};

export type Invoice = Omit<InvoiceSummary, "has_document" | "receipt_count"> & {
  guid: string;
  net_amount: number | null;
  vat_amount: number | null;
  paid_amount: number | null;
  payment_method: string | null;
  payment_reference: string | null;
  notes: string | null;
  document_key: string | null;
  lines: (InvoiceLine & { id: number; line_total: number })[];
  receipts: { id: number; reference: string | null; received_at: string; status: "draft" | "posted"; total: number }[];
};

/** A new invoice pre-filled from a scanned document (see Scan/). */
export type InvoiceDraft = {
  supplier_id: number | null;
  invoice_number: string | null;
  issue_date: string | null;
  due_date: string | null;
  currency: string | null;
  net_amount: number | null;
  vat_amount: number | null;
  total: number | null;
  document_key: string | null;
  lines: InvoiceLine[];
};
